import apiClient from './client';
import { API_BASE_URL } from './client';

export const chatApi = {
  startAgentChat: async (searchContext, modelId = null, pageContext = null, agent = null) => {
    const response = await apiClient.post('/api/v1/agent/chat/start', {
      search_context: searchContext,
      model_id: modelId,
      page_context: pageContext,
      agent: agent,
    }, {
      timeout: 30000
    });
    return response.data;
  },

  sendChatMessage: async (sessionId, message) => {
    const response = await apiClient.post(
      `/api/v1/agent/chat/${sessionId}/message`,
      { message },
      { timeout: 60000 }
    );
    return response.data;
  },

  // Returns URL string for SSE streaming (used with fetch, not axios)
  getChatStreamUrl: (sessionId) => {
    return `${API_BASE_URL}/api/v1/agent/chat/${sessionId}/message/stream`;
  },

  getChatHistory: async (sessionId) => {
    const response = await apiClient.get(`/api/v1/agent/chat/${sessionId}/history`);
    return response.data;
  },

  endChatSession: async (sessionId) => {
    const response = await apiClient.delete(`/api/v1/agent/chat/${sessionId}`);
    return response.data;
  },

  getChatStatus: async () => {
    const response = await apiClient.get('/api/v1/agent/chat/status');
    return response.data;
  },

  getChatConversations: async (limit = 5) => {
    const response = await apiClient.get(`/api/v1/agent/chat/conversations?limit=${limit}`);
    return response.data;
  },

  getChatConversation: async (conversationId) => {
    const response = await apiClient.get(`/api/v1/agent/chat/conversations/${conversationId}`);
    return response.data;
  },

  continueChatConversation: async (conversationId) => {
    const response = await apiClient.post(`/api/v1/agent/chat/conversations/${conversationId}/continue`);
    return response.data;
  },
};
